import User from './User'

export default class AnonymousUser extends User {
  constructor() {
    super([], [])
  }
}
